import { CheckCircle } from "@phosphor-icons/react";
import { createContext, type ReactNode, useCallback, useContext, useRef, useState } from "react";
import { Ic } from "@/components/bits";

const Ctx = createContext<(msg: string) => void>(() => {});
export const useToast = () => useContext(Ctx);

/** Prototype G toast: one dark pill at the bottom, 2.6s. */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState("");
  const [on, setOn] = useState(false);
  const t = useRef<ReturnType<typeof setTimeout>>(undefined);
  const show = useCallback((m: string) => {
    setMsg(m);
    setOn(true);
    clearTimeout(t.current);
    t.current = setTimeout(() => setOn(false), 2600);
  }, []);
  return (
    <Ctx.Provider value={show}>
      {children}
      <div className={`toast${on ? " on" : ""}`} role="status" aria-live="polite">
        <Ic i={CheckCircle} />
        <span>{msg}</span>
      </div>
    </Ctx.Provider>
  );
}

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
